import { CustomCellProps } from 'components/common/grid';
import { Box, Typography } from '@mui/material';
import React from 'react';
import RouteLink from 'components/common/route-link/RouteLink';

export default function CategoryNameCell({ text, href }: CustomCellProps) {
    if (!href) {
        return text;
    }

    const parts = text?.split(' / ');

    if (parts === undefined) {
        return (
            <Typography noWrap>
                <Box component={RouteLink} to={href} sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    {text}
                </Box>
            </Typography>
        );
    }

    const lastIndex = parts.length - 1;
    const nextToLastIndex = parts.length - 2;

    if (parts.length < 4) {
        return (
            <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Box>
                    <Typography noWrap>
                        {parts.map((part, index) => {
                            if (index === lastIndex) {
                                return (
                                    <Box
                                        key={index}
                                        component={RouteLink}
                                        to={href}
                                        sx={{ display: 'inline-flex', alignItems: 'center' }}
                                    >
                                        {part}
                                    </Box>
                                );
                            } else {
                                return `${part} / `;
                            }
                        })}
                    </Typography>
                </Box>
            </Box>
        );
    }

    if (parts.length >= 4) {
        return (
            <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Box>
                    <Typography noWrap>
                        {`${parts[0]} / .. / ${parts[nextToLastIndex]} / `}
                        <Box component={RouteLink} to={href} sx={{ display: 'inline-flex', alignItems: 'center' }}>
                            {parts[lastIndex]}
                        </Box>
                    </Typography>
                </Box>
            </Box>
        );
    }
}
